/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import style from './generalSearch.module.scss';
import cx from 'classnames';
import { useSearchControl } from 'hooks/useSearchControl';
import SearchOverlay from '../core/searchOverlay/searchOverlay';
import SearchButton from '../core/searchButton/searchButton';
import SearchDropdown from '../core/searchDropdown/searchDropdown';
import SearchInputContainer from '../core/searchLineContainer/searchLineContainer';
import GeneralSearchLine from './generalSearchLine/generalSearchLine';
import { isEmpty } from 'lodash-es';
import { MIN_TABLET_WIDTH } from 'utils/utils';
import ClearAll from '../core/clearAll/clearAll';
import { useUniqueKeyHandler } from 'hooks/useKeyHandler';
import { useSearchParams } from 'react-router-dom';
import GeneralSearchTagsMobile from './generalSearchTagsMobile/generalSearchTagsMobile';
import { useViewport } from 'contexts/viewportContext';

export type SearchSection = 'selected' | 'available' | 'create' | 'top';

export type SpecialChipType = 'only_uploaded' | 'only_liked';

export default function GeneralSearch({
  isDisabled = false,
  className = '',
  initialSearch = '',
  overrideSectionTexts,
  baseURL,
}: {
  isDisabled?: boolean;
  className?: string;
  initialSearch?: string; // Начальное значение в строке поиска
  overrideSectionTexts?: { [x: string]: string };
  baseURL?: string;
}) {
  const {
    selected,
    available,
    getChip,
    clearAll,
    top,
    search,
    setSearch,
    availableHash,
  } = useSearchControl({
    isURLSync: true,
  });

  const [isOpen, setIsOpen] = useState(false);
  const keyHandlerId = useUniqueKeyHandler();

  const isLiked = useSearchParams()[0].get('only_liked');
  const isUploaded = useSearchParams()[0].get('only_uploaded');

  const { width } = useViewport();
  //   const isMobileAdaptiveModeOn = window.innerWidth < MIN_TABLET_WIDTH;
  const isMobileAdaptiveModeOn = width <= MIN_TABLET_WIDTH;

  const getSpecialChips = () => {
    const chips = [];

    if (isLiked) {
      chips.push(
        getChip(
          {
            isDeletable: false,
            specialType: 'only_liked',
          },
          {
            name: 'понравившееся',
          }
        )
      );
    }

    if (isUploaded) {
      chips.push(
        getChip(
          {
            isDeletable: false,
            specialType: 'only_uploaded',
          },
          {
            name: 'загруженное',
          }
        )
      );
    }

    return chips;
  };

  useEffect(() => {
    if (initialSearch) {
      setSearch(initialSearch);
    }
  }, [initialSearch]);

  return (
    <>
      <div
        className={cx(
          'searchControl',
          style.container,
          className,
          isDisabled ? 'disabled' : '',
          isOpen ? 'isOpen' : ''
        )}
      >
        <SearchOverlay isOpen={isOpen} setIsOpen={setIsOpen}></SearchOverlay>

        <SearchInputContainer isOpen={isOpen}>
          <GeneralSearchLine
            setIsOpen={setIsOpen}
            isDisabled={isDisabled}
            setSearch={setSearch}
            search={search}
            getChip={getChip}
            selected={selected}
            isOpen={isOpen}
            getSpecialChips={getSpecialChips}
          ></GeneralSearchLine>
        </SearchInputContainer>

        <SearchButton
          selected={selected}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          baseURL={baseURL}
          keyHandlerId={keyHandlerId}
        ></SearchButton>

        {/* Выпадашка */}
        <SearchDropdown
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          sectionsOrder={['available']}
          selected={selected}
          available={available}
          overrideSectionTexts={overrideSectionTexts}
          getChip={getChip}
          search={search}
          availableHash={availableHash}
          top={top}
          keyHandlerId={keyHandlerId}
        ></SearchDropdown>
      </div>

      {/* В мобильном разрешении рендерим теги под поисковой строкой */}
      {isMobileAdaptiveModeOn && (
        <GeneralSearchTagsMobile
          selected={selected}
          getChip={getChip}
        ></GeneralSearchTagsMobile>
      )}

      <div style={{ opacity: !isEmpty(selected) ? 1 : 0 }}>
        <ClearAll clearAll={clearAll}></ClearAll>
      </div>
    </>
  );
}
